export const matchFilters = (note,filters,search) => {
    if (search.trim()){
        const title = note.title.toLowerCase().trim()
        const content = note.content.toLowerCase().trim()
        const searchValue = search.toLowerCase().trim()
        if (!title.includes(searchValue) && !content.includes(searchValue)){
            return false
        }
    }
    if (filters.color){
        if (note.color !== filters.color.name){
            return false
        }
    }
    if (filters.tags.length){
        const note_tags = note.tags.map(tag => tag._id.toString())
        const filtered_tags = filters.tags.map(tag => tag._id.toString())
        if (!note_tags.some(tag => filtered_tags.includes(tag))){
            return false
        }
    }
    return true
}

export const sortNotes = (notes,sortParams) => {
    return notes.sort((noteA,noteB)=>{
        if (noteA[sortParams.field] < noteB[sortParams.field]) return sortParams.order === 'asc' ? -1 : 1
        if (noteA[sortParams.field] > noteB[sortParams.field]) return sortParams.order === 'asc' ? 1 : -1
        return 0
    })
}

export const sanitizeNotes = (notes,sortParams,filterParams,search) => {
    const data = notes.filter(note => matchFilters(note,filterParams,search))
    return sortNotes(data,sortParams)
}